<script setup>
const props = defineProps({
  text: String,
  size: String,
});
</script>

<template>
  <div class="">
    <div class="error__container">
      <div class="error__text">
        <p class="mb-0" v-html="text"></p>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.error__container {
  background-color: #ff9999;
  padding: 10px 15px;
  border-radius: 0.5em;
  text-align: center;
  .error__text {
    color: #3d3b3b;
    p {
      font-family: 'CircularStd-Book';
      font-size: 14px;
      margin-bottom: 0;
    }
  }
}
</style>
